/* @flow */
import React from 'react';
import {
	AddressLine,
	AddressWithIcon,
	AddressWrapper,
	HeaderWrapper,
	LocationIcon,
	MetroLine,
	Title,
	TitleWrapper,
} from '../styles';
import { locationIcon } from '../../Icons';
import { LinkButton } from '../../ApartResalePage/styles';
import type { TBuilding, TMetro } from '../../../types/apart';
import { TComplex, THouseResale } from '../../../types/apart';
import MetroName from '../../MetroName';
import type { TCity } from '../../../types/city';

type TProps = {
	apartTitle: string,
	data: THouseResale | TComplex,
	withMap: boolean,
	handleMapClick: () => {},
	city: TCity,
	cityTitle: string,
	building?: TBuilding,
	isNew?: boolean,
};

const ApartTitle = ({ apartTitle, data, withMap, handleMapClick, city, cityTitle, building, isNew }: TProps) => (
	<TitleWrapper>
		<Title itemProp="name" data-qa="apart_name">
			{apartTitle}
		</Title>
		<HeaderWrapper>
			<AddressWrapper>
				{!!data.addressText && (
					<AddressLine data-qa="apart_address">
						<AddressWithIcon>
							<LocationIcon>{locationIcon}</LocationIcon>
							{cityTitle && `${cityTitle}, `}
							{data?.area?.name && `${data.area.name}, `}
							{data.addressText && `${data.addressText}`}
							{!!building?.number && `, корпус ${building.number}`}&ensp;
							{withMap && (
								<LinkButton onClick={handleMapClick} isBig style={{ flexShrink: 0 }}>
									На карте
								</LinkButton>
							)}
						</AddressWithIcon>
					</AddressLine>
				)}
				{data?.metro?.length > 0 && (
					<MetroLine data-qa="apart_subway">
						{data?.metro.map(
							(station: TMetro) =>
								station.name && (
									<MetroName
										key={station.name}
										isNew={isNew}
										city={city}
										station={station}
										withDistance
										wrapped
									/>
								),
						)}
					</MetroLine>
				)}
			</AddressWrapper>
		</HeaderWrapper>
	</TitleWrapper>
);

ApartTitle.defaultProps = {
	building: undefined,
	isNew: false,
};

export default ApartTitle;
